import React from "react";
import { useDispatch, useSelector } from "react-redux";

//import MUI
import { Modal } from "antd";

// import APIs
import CreateApi from "../../api/customer/address/Create";

// redux
import { setMetaData } from "../../redux/reducers/page";
import { setAuth } from "../../redux/reducers/customer";

import { validateMobile } from "../../helpers/NumberTools";


// form elements

import TextField from "../formElement/TextField";
import Autocomplete from "../formElement/Autocomplete";
import NumberField from "../formElement/NumberField";

import { ErrorNotify, SuccessNotify } from "../../ui/Toast";

const AddAddress = (props) => {
  const dispatch = useDispatch();

  const { allStates } = useSelector((state) => state.page);
  const states = allStates;
  const [sending, setSending] = React.useState(false);
  const [cities, setCities] = React.useState([]);
  const [recipientsName, setRecipientsName] = React.useState(null);
  const [provinceId, setProvinceId] = React.useState(null);
  const [cityId, setCity] = React.useState(null);
  const [recipientsAddress, setRecipientsAddress] = React.useState(null);
  const [postalCode, setPostalCode] = React.useState(null);
  const [plaque, setPlaque] = React.useState(null);
  const [recipientsPhone, setPecipientsPhone] = React.useState(null);
  const [recipientsMobiles, RecipientsMobiles] = React.useState(null);
  const { openModal, setOpenModal, auth, setAddresses } = props;

  const stateOptions = [];
  for (const state of states) {
    stateOptions.push({
      value: state.id,
      label: state.label,
    });
  }

  const setState = (id) => {
    if (id) {
      setProvinceId(id);
      const cities = states.find((i) => i.id === id).cities;
      const opts = [];
      for (const city of cities) {
        opts.push({
          value: city.id,
          label: city.name,
        });
      }
      setTimeout(() => setCities(opts), 1);
    }
  };

  const submitForm = async () => {
    if (recipientsName === null) {
      ErrorNotify(" نام تحویل گیرنده وارد نشده ");
      return;
    }
    if (provinceId === null) {
      ErrorNotify("  استان را انتخاب نشده  ");
      return;
    }
    if (cityId === null) {
      ErrorNotify("  شهرستان را انتخاب نشده  ");
      return;
    }

    if (recipientsAddress === null) {
      ErrorNotify(" نشانی وارد نشده ");
      return;
    }
    if (postalCode === null || postalCode.length !== 10) {
      ErrorNotify(" لطفا کدپستی را صحیح وارد کنید ");
      return;
    }
    if (recipientsMobiles === null) {
      ErrorNotify(" شماره همراه وارد نشده ");
      return;
    }
    if (!recipientsMobiles || recipientsMobiles.length < 11) {
      ErrorNotify("شماره موبایل صحیح وارد نشده");
      return;
    }
    if (!validateMobile(recipientsMobiles)) {
      ErrorNotify(" شماره موبایل وارد شده معتبر نیست ");
      return;
    }

    setSending(true);
    const result = await CreateApi(
      auth.token,
      recipientsName,
      provinceId,
      cityId,
      recipientsAddress,
      postalCode,
      plaque,
      recipientsPhone || recipientsMobiles,
      recipientsMobiles
    );
    if (result.status === 403) {
      dispatch(
        setAuth({
          token: null,
          customer: null,
          isAuthenticated: false,
          newBasket: null,
        })
      );
      return;
    }
    if (result.status === 400) {
      ErrorNotify(" مقادیر به درستی وارد نشده است ");
      setSending(false);
      return;
    }
    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      setSending(false);
      return;
    }
    if (result.status === 200) {
      SuccessNotify("نشانی با موفقیت ثبت شد");
      setAddresses(result.data);
      setCities([]);
      setRecipientsName(null)
      setProvinceId(null);
      setCity(null);
      setRecipientsAddress(null);
      setPostalCode(null);
      setPlaque(null);
      setPecipientsPhone(null);
      RecipientsMobiles(null);
      setSending(false);
      setOpenModal(false);
      return;
    }
  };
  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت :    نشانی جدید",
        description: "میشرت:   نشانی جدید",
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      title="ثبت نشانی جدید"
      centered
      open={openModal}
      onOk={() => submitForm()}
      okButtonProps={{ disabled: sending }}
      onCancel={() => setOpenModal(false)}
      okText={"تایید"}
      cancelText="انصراف"
    >
      <div className="col-12">
        <hr className="p-0 m-1" />
        <div className="row">
          <div className="col-12 p-0 ">
            <TextField
              required={true}
              name="title"
              label="تحویل گیرنده"
              type="text"
              onChange={(e) => setRecipientsName(e.target.value)}
            />
          </div>

          <div className="col-6 pl-1  pr-0 ">
            <Autocomplete
              options={stateOptions}
              defaultValue={null}
              name="proDist"
              label="استان "
              setValue={setState}
            />
          </div>
          {cities && cities.length !== 0 ? (
            <div className="col-6 p-0 m-0 ">
              <Autocomplete
                options={cities}
                defaultValue={null}
                setValue={setCity}
                name="city"
                label="شهرستان "
              />
            </div>
          ) : (
            <div className="col-6 pr-1  pl-0 ">
              <Autocomplete
                options={[]}
                defaultValue={null}
                setValue={setCity}
                name="cityDist"
                label="شهرستان "
              />
            </div>
          )}
          <div className="col-12 p-0 ">
            <TextField
              required={true}
              name="title"
              label="نشانی  "
              type="text"
              onChange={(e) => setRecipientsAddress(e.target.value)}
            />
          </div>

          <div className="col-12 p-0 ">
            <NumberField
              required={true}
              name="title"
              label=" کدپستی "
              type="text"
              onChange={(e) => setPostalCode(e.target.value)}
            />
          </div>
          <div className="col-12 p-0 ">
            <NumberField
              required={false}
              name="title"
              label=" پلاک  "
              type="text"
              rows={3}
              multiline={true}
              onChange={(e) => setPlaque(e.target.value)}
            />
          </div>
          <div className="col-12 p-0 ">
            <NumberField
              required={true}
              name="title"
              label="شماره همراه  "
              type="text"
              rows={3}
              multiline={true}
              onChange={(e) => RecipientsMobiles(e.target.value)}
            />
          </div>
          <div className="col-12 p-0 ">
            <NumberField
              required={false}
              name="title"
              label="شماره تماس  "
              type="text"
              rows={3}
              multiline={true}
              onChange={(e) => setPecipientsPhone(e.target.value)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AddAddress;
